import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { initiateNearmapRequest, nearmapJobHistory } from "../../../api/routes";
import { NearmapJobHistoryItem, WorkStatus } from "../../../client/types.gen";

const nearmapKeys = {
  history: (reportId: string) => ["nearmap-history", reportId] as const,
};

const NEARMAP_POLL_INTERVAL_MS = 2000;

const isNearmapJobActive = (job: NearmapJobHistoryItem): boolean =>
  job.status === WorkStatus.PENDING || job.status === WorkStatus.IN_PROGRESS;

export const useNearmapHistory = (reportId: string) =>
  useQuery({
    queryKey: nearmapKeys.history(reportId),
    queryFn: () => nearmapJobHistory(reportId),
    refetchInterval: (query) => {
      const jobs = query.state.data?.jobs ?? [];
      return jobs.some(isNearmapJobActive) ? NEARMAP_POLL_INTERVAL_MS : false;
    },
  });

export const useTriggerNearmap = (reportId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => initiateNearmapRequest(reportId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: nearmapKeys.history(reportId),
      });
    },
  });
};
